import $ from 'jquery';

export default class JobOpenings {
    constructor() {
        this.selectors = {
            jobviteSection: '.jobvite-section .cmg-container-new',
            filter: '#openings_filter',
            iframe: '#contact_iframe',
        };

        this.init();
    }

    init() {
        this.$filter = $(this.selectors.filter);
        this.$iframe = $(this.selectors.iframe);
        this.$jobviteSection = $(this.selectors.jobviteSection);

        this.bind();
    }

    bind() {
        this.$filter.on('change', e => {
            this.$iframe.remove();
            $('<iframe title="JobList" id="contact_iframe" src="' + e.target.value + '" width="100%" frameborder="0"></iframe>').appendTo(this.selectors.jobviteSection);
            this.$iframe = $(this.selectors.iframe);
        });
    }
}